import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import AccommodationTextList from './AccommodationTextList'

type Props = {
  maximumRoomCapacities: Array<string>
}

function AccommodationMaximumRoomCapacities({ maximumRoomCapacities }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: '_VYJWxjzFF0zQLXVBjmV',
    defaultMessage: 'Maximum room capacity',
    description: 'Heading for the maximum room capacity section within the guest policy area of the room details modal.',
  })

  return (
    <>
      <BodyText variant="medium" weight="bold" as="h4">{heading}</BodyText>
      <AccommodationTextList items={maximumRoomCapacities} />
    </>
  )
}

export default AccommodationMaximumRoomCapacities
